import { NewTabLink } from '../Link';

export function DocsAPIKeys() {
  return (
    <NewTabLink href="https://tolgee.io/platform/account_settings/api_keys_and_pat_tokens">
      Learn more in Docs
    </NewTabLink>
  );
}
